import { render, staticRenderFns } from "./ArticlesInfo.vue?vue&type=template&id=21b0fe34&"
import script from "./ArticlesInfo.vue?vue&type=script&lang=js&"
export * from "./ArticlesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports